export type CategoryCard = {
  id: string;
  title: string;
  description: string;
  route: string;
  icon: string;
};

export type ActionCard = {
  id: string;
  title: string;
  description: string;
  route: string;
  icon: string;
};

export const intelliDocSuiteCategories: CategoryCard[] = [
  {
    id: "contractiq",
    title: "ContractIQ",
    description: "Manage contracts, upload documents, and access templates",
    route: "/contractiq",
    icon: "document"
  },
  {
    id: "prizelogic",
    title: "PrizeLogic",
    description: "Access and review PrizeLogic templates",
    route: "/prizelogic",
    icon: "trophy"
  }
];

export const contractIQActions: ActionCard[] = [
  {
    id: "contract-list",
    title: "Contract List",
    description: "Select and review contract documents",
    route: "/contractiq/contracts",
    icon: "list"
  },
  {
    id: "upload-review",
    title: "Upload and Review",
    description: "Direct access to contract review workflow",
    route: "/contractiq/upload",
    icon: "upload"
  },
  {
    id: "template-library",
    title: "Template Library",
    description: "Generate contracts and descriptions from template library",
    route: "/contractiq/templates",
    icon: "template"
  }
];

export const prizeLogicActions: ActionCard[] = [
  {
    id: "create",
    title: "Extract Input Fields & Section",
    description:
      "Upload a document, define one section, extract AI fields, and save immediately to the Knowledgebase. 3-step workflow.",
    route: "/prizelogic/create-template",
    icon: "document",
  },
  {
    id: "generate",
    title: "Generate Document",
    description:
      "Describe your game rule, get AI-recommended sections, fill inputs, select AI content, and generate. 5-step flow.",
    route: "/prizelogic/generate-document",
    icon: "sparkles",
  },
  {
    id: "documents",
    title: "Generated Documents",
    description:
      "View in-progress drafts and completed rules. Resume a draft or open a document for review.",
    route: "/prizelogic/listing",
    icon: "stack",
  },
];
